import { render, staticRenderFns } from "./LuxuryPrizeWheel.vue?vue&type=template&id=13473406&scoped=true&"
import script from "./LuxuryPrizeWheel.vue?vue&type=script&lang=js&"
export * from "./LuxuryPrizeWheel.vue?vue&type=script&lang=js&"
import style0 from "./LuxuryPrizeWheel.vue?vue&type=style&index=0&id=13473406&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13473406",
  null
  
)

export default component.exports